export const TableHeaderCaptions = ({ subtitle, title }: { subtitle?: string; title: string }) => (
  <>
    <span className="block leading-none">{title}</span>

    {subtitle ? <span className="font-light">{subtitle}</span> : null}
  </>
);
